const registrationTypeTypes = {
	Myself: {
		name: "Myself",
		value: "Individual (Myself)"
	},
	SomeoneElse: {
		name: "Someone Else",
		value: "Individual (Someone Else)"
	}
};

const registrationTypeOptions = [
	{ name: registrationTypeTypes.Myself.name, value: registrationTypeTypes.Myself.value },
	{ name: registrationTypeTypes.SomeoneElse.name, value: registrationTypeTypes.SomeoneElse.value }
];

const registrationTypeSearchOptions = [
	{ name: registrationTypeTypes.Myself.name, value: registrationTypeTypes.Myself.value },
	{ name: registrationTypeTypes.SomeoneElse.name, value: registrationTypeTypes.SomeoneElse.value }
];

const registrationTypes = {
	types: registrationTypeTypes,
	searchOptions: registrationTypeSearchOptions,
	options: registrationTypeOptions
};

export default registrationTypes;
